$(".l-header-account-button").on("click", function(){
  // console.log("ff")
  $(".l-header-account-window").toggleClass("is-show");
})

$(document).click(function (event) {
  if (!$(event.target).closest('.l-header-account-window.is-show').length && !$(event.target).closest('.l-header-account-button').length) {
    $(".l-header-account-window").removeClass("is-show");
  } else {
    // console.log('内側がクリックされました。');
  }
});